import React, { useState, useEffect } from "react";
import { uploadImageToCloudinary } from "../cloudinary";
import { db } from "../firebase";
import { collection, addDoc, updateDoc, doc } from "firebase/firestore";

const AddCategoryModal = ({ isOpen, onClose, onCategoryAdded, categoryToEdit }) => {
  const [name, setName] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // Rellena datos si es edición
  useEffect(() => {
    if (categoryToEdit) {
      setName(categoryToEdit.name || "");
      setImagePreview(categoryToEdit.image || null);
      setImageFile(null);
    } else {
      setName("");
      setImagePreview(null);
      setImageFile(null);
    }
  }, [categoryToEdit, isOpen]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let imageUrl = imagePreview;

    // Si hay nuevo archivo, sube la imagen
    if (imageFile) {
      imageUrl = await uploadImageToCloudinary(imageFile);
    }

    if (categoryToEdit) {
      // EDITAR
      await updateDoc(doc(db, "categorias", categoryToEdit.id), {
        name,
        image: imageUrl,
      });
    } else {
      // NUEVA
      await addDoc(collection(db, "categorias"), {
        name,
        image: imageUrl,
        createdAt: new Date()
      });
    }
    setLoading(false);
    onCategoryAdded();
    onClose();
    setName(""); setImageFile(null); setImagePreview(null);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md relative"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">
          {categoryToEdit ? "Editar Categoría" : "Agregar Categoría"}
        </h2>
        <input
          type="text"
          placeholder="Nombre de la categoría"
          className="w-full p-2 mb-3 border rounded"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="file"
          accept="image/*"
          className="mb-3"
          onChange={handleImageChange}
        />
        {imagePreview && (
          <img src={imagePreview} alt="preview" className="w-32 h-32 object-cover mb-4 mx-auto rounded" />
        )}
        <button
          type="submit"
          className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-all"
          disabled={loading}
        >
          {loading
            ? categoryToEdit
              ? "Actualizando..."
              : "Subiendo..."
            : categoryToEdit
              ? "Actualizar Categoría"
              : "Guardar Categoría"}
        </button>
        <button
          type="button"
          className="w-full mt-3 text-gray-500 hover:text-gray-900"
          onClick={onClose}
        >
          Cancelar
        </button>
      </form>
    </div>
  );
};

export default AddCategoryModal;
